import { createSlice } from '@reduxjs/toolkit';

export const companySlice = createSlice({
    name: 'company',
    initialState: {
            type_documents_list: [],
            countries_list: [],
            municipalies_list: [],
            sites_list: [],
            payment_frequency_list: [],
            payment_method_list: [],
            associated_bank_list: [],
            type_account_bank_list: [],
            sgsst_list: [],
            arl_list: [],
    },
    reducers: {
        setInputsForm: ( state, { payload } ) => {
            
            state.type_documents_list    =  payload.type_documents_list;
            state.countries_list         =  payload.countries_list;
            state.municipalies_list      =  payload.municipalies_list;
            state.sites_list             =  payload.sites_list;
            state.payment_frequency_list =  payload.payment_frequency_list;
            state.payment_method_list    =  payload.payment_method_list;
            state.associated_bank_list   =  payload.associated_bank_list;
            state.type_account_bank_list =  payload.type_account_bank_list;
            state.sgsst_list             =  payload.sgsst_list;
            state.arl_list               =  payload.arl_list;
        }
        
    }
});


// Action creators are generated for each case reducer function
export const { setInputsForm } = companySlice.actions;